export function toCapitalize(str: string) {
  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`
}

export function toCamelCase(str: string) {
  return str.replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase())
}
